var parallel = require("./browser").default;
module.exports = parallel;


//////////////////
// WEBPACK FOOTER
// ./src/api/browser-commonjs.js
// module id = 168
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/api/browser-commonjs.js